import { render, staticRenderFns } from "./bodyprint-skeleton.vue?vue&type=template&id=2cb83542"
import script from "./bodyprint-skeleton.vue?vue&type=script&lang=js"
export * from "./bodyprint-skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports